/** Trim and return only firts 50 characters of a string */
export const eliipsizeText = (txt) => txt.slice(0,30)+"...";

export const ellispisis = (text, length) => {
    if (text?.length > length) {
        return text?.slice(0,length)+"..."
    }
    return text;
}


/** paginate */
export const paginateData = (page, data) => {
    const pageData = data.slice((page - 1)*5, (page - 1)*5 + 5);
    return pageData;
}

export const isNull = (value) => value === undefined || value === '' || value === null;